var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teams-config"},[_c('h3',{staticClass:"teams-config-title"},[_vm._v(_vm._s(_vm.$t('teams_apps.the_tab_is_configured')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('teams_apps.press_the_save_button_at_the_bottom_of_this_screen')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }